import React from "react"
import Layout from "../components/layout"
import SearchBar from "../components/searchbar"
import SEO from "../components/seo"
import { Link } from "gatsby"

import "../components/style.css"

const contact = () => (
  <>
    <Layout>
      <SEO title="Contact Us - Global Facebook Marketplace Search" />
      <div className="container">
        <div className="centered">
          <div className="style1">
            <h1 className="style1">Contact Us</h1>
          
          </div>
        </div>
      </div>

      <div className="contact-section">
        <div className="contact-content">
          <div className="contact-info">
            <h2>About SearchWorldMarketplace</h2>
            <p>SearchWorld Marketplace was created to help users find items for sale on Facebook Marketplace beyond the standard 100-mile radius. Our platform connects buyers and sellers across the globe, making it easier to find exactly what you're looking for.</p>
            
            <h3>Contact Information</h3>
            <p>Email: <a href="mailto:sales@njtautomtion.com">sales@njtautomation.com</a></p>
            <p>Location: Milwaukee, Wisconsin</p>
            
            <h3>Technical Information</h3>
            <p>Platform: React + Gatsby</p>
            <p>Created: October 2019</p>
          </div>

          <div className="recommendations">
            <h3>Recommended Services</h3>
            <div className="recommendation-card card-njt">
              <span className="card-label">Supply & Repair</span>
              <h4><a href="https://njtautomation.com/" target="_blank" rel="noopener" title="NJT Automation - Industrial Electronics Supply and Repair">NJT Automation</a></h4>
              <p>Your trusted source for industrial automation components, repair, and services:</p>
              <ul>
                <li><a href="https://njtautomation.com/industrial-electronics-repair/" target="_blank" rel="noopener" title="Industrial Electronics Repair - HMI, PLC, VFD Repair Services"><strong>Industrial Electronics Repair</strong></a> - HMI, PLC, VFD & Servo Drive repair with 1-year warranty</li>
                <li><a href="https://njtautomation.com/" target="_blank" rel="noopener" title="Buy Allen-Bradley Industrial Components">Buy Allen-Bradley components</a> - PLCs, PanelViews, Drives</li>
                <li><a href="https://njtautomation.com/" target="_blank" rel="noopener" title="Sell Surplus Industrial Automation Parts">Sell your surplus parts</a></li>
              </ul>
              <div className="card-footer-link">
                <a href="https://njtautomation.com/" target="_blank" rel="noopener">njtautomation.com →</a>
              </div>
            </div>
            <div className="recommendation-card card-repairmode">
              <span className="card-label">Repair Network</span>
              <h4>
                <a 
                  href="https://repairmode.com" 
                  target="_blank" 
                  rel="noopener"
                  title="RepairMode - Electronics Repair Marketplace"
                >
                  RepairMode
                </a>
              </h4>
              <p>Distributed-technician electronics repair marketplace connecting businesses with specialized repair technicians:</p>
              <ul>
                <li>
                  <a 
                    href="https://repairmode.com" 
                    target="_blank" 
                    rel="noopener"
                    title="RepairMode - Get Electronics Repair Quotes"
                  >
                    <strong>Get Repair Quotes</strong>
                  </a> - Photo-based repair bidding from qualified technicians
                </li>
                <li>
                  <a 
                    href="https://repairmode.com" 
                    target="_blank" 
                    rel="noopener"
                    title="RepairMode - Industrial Electronics Repair Network"
                  >
                    Industrial Electronics Repair
                  </a> - HMIs, PLCs, VFDs, Servo Drives
                </li>
              </ul>
              <div className="card-footer-link">
                <a href="https://repairmode.com" target="_blank" rel="noopener">repairmode.com →</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SearchBar />
    </Layout>
  </>
)

export default contact
